// removed by extract-text-webpack-plugin
module.exports = {"note":"fQvW6y10xoWhUHzpIPgJp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Note.scss
// module id = 1109
// module chunks = 0